// removed by extract-text-webpack-plugin
module.exports = {"cornerMarker":"cornerMarker___13ONQ","textContent":"textContent___2JxZE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CornerMarker/index.modules.less
// module id = 1210
// module chunks = 418